import { Flex } from "common/components/flex/flex";
import { DashboardRow } from "./components/dashboardRow/dashboardRow";
import { WeeklyActivity } from "./sections/weeklyActivity/weeklyActivity";
import { OpenPendingJobs } from "./sections/jobs/openPendingJobs";
import { Tasks } from "./sections/tasks/tasks";
import { PostOfferMetrics } from "./sections/postOfferMetrics/postOfferMetrics";
import { PipelineCandidates } from "./sections/candidates/pipelineCandidates";
import { MonthlyGoals } from "./sections/monthlyGoals/monthlyGoals";

export const DashboardContainer = ({ clientId, recruiterId }) => {
  return (
    <Flex direction="column" gap={16}>
      <WeeklyActivity clientId={clientId} recruiterId={recruiterId} />
      <Tasks clientId={clientId} recruiterId={recruiterId} />

      <DashboardRow
        main={
          <PipelineCandidates clientId={clientId} recruiterId={recruiterId} />
        }
        secondary={
          <MonthlyGoals clientId={clientId} recruiterId={recruiterId} />
        }
        secondaryWidth={360}
      />

      <DashboardRow
        main={<OpenPendingJobs clientId={clientId} recruiterId={recruiterId} />}
        secondary={
          <PostOfferMetrics clientId={clientId} recruiterId={recruiterId} />
        }
        secondaryWidth={360}
      />
    </Flex>
  );
};
